import styled from "styled-components";
export const StyledInput = styled.input `
  position: absolute;
  opacity: 0;
  cursor: pointer;
  width: 100%;
  height: 100%;
`;
export const StyledCheckbox = styled.div `
  position: relative;
  width: fit-content;
  svg {
    pointer-events: none;
  }
`;
//# sourceMappingURL=Checkbox.style.js.map